import styles from './jenjang.module.css'

import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { SatpenTableItemStats } from '@/apis/types'

interface JenjangStatsProps {
  items: SatpenTableItemStats[]
}

export const JenjangStats = ({ items }: JenjangStatsProps) => {
  const itemsBody = (items || []).filter((i) => !i.footer) || []
  return (
    <div
      className={clsx(
        'mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:flex lg:grid-cols-11',
        styles.jenjangStatsWrapper
      )}
    >
      {itemsBody.map((item) => (
        <div key={item.text}>
          <Text
            color="inverse"
            variant={item.text === 'Total' ? 'helper-bold' : 'helper'}
            data-testid={`txt-stat-label-${item.id}`}
          >
            {item.text}
          </Text>
          <Text
            color="inverse"
            variant={item.text === 'Total' ? 'body-sm-bold' : 'body-sm'}
            data-testid={`txt-stat-val-${item.id}`}
          >
            {new Intl.NumberFormat('id-ID', {}).format(item.value)}
          </Text>
        </div>
      ))}
    </div>
  )
}
